<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='pageSub'">
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{ this.djTitle }}</div>
                <div class="left-head-container">
                    <el-form-item class="pull-right">
                        <el-input v-model="queryParams.title" placeholder="请输入名称搜索" class="input-with-select">
                            <template #append>
                                <el-button type="primary" @click="pageList(null)" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                            </template>
                        </el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="right-container">
                <div class="info-list-container">
                    <div class="dj-item" v-for="item in dataList" :key="item.dangjId">
                        <div class="dj-yuan"></div>
                        <div class="dj-item-l" @click="viewDangj(item)">{{item.title}}</div>
                        <div class="dj-item-r">{{ timestampDate(item.releaseTime) }}</div>
                    </div>
                    <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                </div>
                <div class="page-container" v-if="dataList&&dataList.length>0">
                    <pageTag :background="true"
                             :pageSizes="[10, 20, 30]"
                             v-show="total > 0"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageList" />
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detailSub'">
            <div class="dj-container">
                <div class="head-container">
                    <div class="left-head-container" @click="pageView">
                        <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                    </div>
                    <div class="right-head-container">{{ form.title }}</div>
                    <div class="left-head-container">
                    </div>
                </div>
                <div class="dj-time">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
                <div class="dj-content" v-html="form.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import dangjInfo from "@/components/resourceCentre/dangjInfo.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {infoDangj, pageDangj} from "@/api/admin/dangj";

export default {
    name:'pageDangj',
    components:{pageTag, dataEmpty,dangjInfo},
    props:{
        infoMode:{
            type: String,
            default:null
        },
        title:{
            type: String,
            default:null
        },
        subTitle:{
            type: String,
            default:null
        },
        djType:{
            type: String,
            default:null
        },
    },
    watch:{
        infoMode(newValue,oldValue){
            this.showMode = 'pageSub';
        },
        title(newValue,oldValue){
            this.djTitle = newValue;
        },
        subTitle(newValue,oldValue){
            this.djSubTitle = newValue;
            this.showMode = 'pageSub';
        },
        djType(newValue,oldValue){
            this.category = newValue;
            this.pageList();
        },
    },
    mounted() {
        this.pageList()
    },
    data() {
        return {
            showMode:'pageSub',
            djTitle:'',
            djSubTitle:'',
            timestampDate,
            category:'1',
            queryParams: {
                category:'',
                title:'',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            dangjId:'',
            form:{},  //数据
            timestampToTime,
        }
    },
    methods: {
        pageList(){
            this.queryParams.category = this.category
            pageDangj(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewDangj(item){
            this.dangjId = item.dangjId;
            this.getDangjInfo();
            this.showMode = "detailSub"
        },
        pageView(){
            this.showMode = "pageSub"
            // this.$emit('change-mode',this.showMode);
        },
        backList(){
            this.showMode = "page"
            this.$emit('change-mode',this.showMode);
        },
        getDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },

    }
}

</script>

<style lang="scss" scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
/*列表模式：一屏显示，页面不滚动（条目过多时仅列表内部滚动）*/
.page-mode{
    width: 100%;
    height: calc(100vh - 200px);
    background-color: #fff;
    border-radius: 16px;
    padding: 10px 28px 10px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.head-container{
    flex-shrink: 0;
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
/deep/ .el-form-item{
    margin-bottom: 0;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.right-container{
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}
.info-list-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.dj-item{
    width: 100%;
    height: 40px;
    display: flex;
    border-bottom: 1px dashed #eef2f7;
}
.dj-item-l{
    width: calc(100% - 100px);
    height: 40px;
    color: #434343;
    line-height: 40px;
    font-size: 15px;
    padding-left: 8px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.dj-item-l:hover{
    color: #0d55a4!important;
}
.dj-item-r{
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #999999;
    text-align: right;
    flex-shrink: 0;
}
.dj-yuan{
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #0d55a4;
    margin-top: 17px;
    flex-shrink: 0;
}
.page-container{
    flex-shrink: 0;
    display: grid;
    place-items: center;
    width: 100%;
    padding-top: 12px;
    box-sizing: border-box;
}
/*详情模式：白色卡片，内容在卡片内滚动*/
.detail-mode{
    width: 100%;
}
.dj-container{
    width: 100%;
    height: calc(100vh - 194px);
    overflow-y: auto;
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 28px 30px;
    box-sizing: border-box;
}
.dj-time{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    width: 100%;
    overflow-x: hidden;
}
.dj-content /deep/ img{
    max-width: 100%;
}
</style>